export { default as SoundIcon } from '~icons/f7/speaker-2-fill';
